import { createFileRoute } from "@tanstack/react-router";
import SupportPage from "src/components/app/SupportPage/SupportPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { raceLoaderData } from "src/lib/LoaderResult";
import { getSupportPageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/support")({
  loader: () => raceLoaderData(getSupportPageData()),
  component: SupportRoute,
});

function SupportRoute() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <SupportPage initialPage={data?.initialPage} />}
    </DeferredLoaderData>
  );
}
